export const enum PensionMixpanelEvents {
  THE_USER_CLICKED_ON_PENSION_COMPANY_NAME_OR_DIDNT_FIND_A_RELEVANT_OPTION_OR_PREFER_TO_ADD_MANUALLY = `The user clicked on a pension company name/  (I did not find a relevant option or
        Prefer to add manually)`,
  THE_USER_CLICKS_YES_OR_NO_ON_THE_LIQUDITY_AVILABILITY = "the user clicks yes/ no at the liqudity avilability",
  THE_USER_CLICKS_ON_THE_X_BTN = "The user clicks on X button",
  THE_USER_CLICKS_ON_THE_TRASH_BTN = "The user clicks on the trash button",
  THE_USER_CLICKS_ON_THE_SAVE_BUTTON = "The user clicks on the save button",
  THE_USER_CLICKS_ON_THE_PENSION_ACCOUNT_FROM_ASSET_TABLE = "The user clicked on the Pension account from the asset table",
  THE_USER_CLICKS_ON_A_TAB = "The user clicks on a tab",
  DELETE_PENSION_ACCOUNT = "delete pension account",
  EDIT_PENSION_ACCOUNT = "edit pension account",
  ADD_PENSION_ACCOUNT = "add pension account",
  PRESSING_ON_IMPORT_FROM_MASLEKA_BUTTON = "Pressing on import from masleka button",
  EXITING_FROM_THE_FIRST_STAGE_MASLEKA_FORM = "Exiting from the first stage masleka form",
  EXITING_FROM_THE_SECOND_STAGE_MASLEKA_FORM = "Exiting from the  payment- second stage masleka form",
  PRESSING_END_CONFIRMATION_POPUP = "pressing on end from confirmation pop up",
  PRESSING_TRY_AGAIN_FAILED_POPUP = "pressing on try again from fail payment pop up",
}

export const EndMaslekaFormBy = {
  SUBMIT: "submit form",
  EXIT_FORM: "exit form",
} as const;
export type EndMaslekaFormBy =
  typeof EndMaslekaFormBy[keyof typeof EndMaslekaFormBy];

export const EndYaadSarigModalBy = {
  CONTINUE: "continue",
  CLOSE: "close",
} as const;
export type EndYaadSarigModalBy =
  typeof EndYaadSarigModalBy[keyof typeof EndYaadSarigModalBy];
